import { render, staticRenderFns } from "./HacermeSocio.vue?vue&type=template&id=13c36742&"
import script from "./HacermeSocio.vue?vue&type=script&lang=js&"
export * from "./HacermeSocio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports